module.exports = __webpack_public_path__ + "media/images/bluepinrts_white_title_bg-86762a04895f388c24d45e23677216a7.png";